import banner from "../../assets/img/service-banner6.avif";
const data = [
  {
    title: "Deep Aviation Industry Focus",
    description:
      "We understand the unique complexities of aviation procurement—from sourcing critical GGAS components and ground support equipment to managing MRO supply chains. Our expertise ensures compliance with industry regulations and alignment with technical and operational standards.",
  },
  {
    title: "Collaborative, Innovative Solutions",
    description:
      "We work closely with your team to design and implement tailored, innovative procurement and supply chain strategies. Our solutions leverage the latest technologies and best practices to optimize costs, improve efficiency, and enhance supplier relationships.",
  },
  {
    title: "Experienced Aviation Consultants",
    description:
      "Our consultants bring extensive hands-on experience in aviation procurement, supply chain logistics, and supplier management. This deep knowledge allows us to address your challenges quickly and effectively, providing measurable results from day one.",
  },
  {
    title: "Agile & Flexible Engagement",
    description:
      "GGAS offers flexible service models, from targeted sourcing support and logistics assistance to full-scale supply chain transformation programs. Our streamlined approach means less bureaucracy and faster delivery tailored to your operational needs.",
  },
];
const Procurement = () => {
  return (
    <>
      <section className="serviceSection sectionPD">
        <div className="container">
          <div className="fisherman-content">
            <h3>Aviation Procurement & Supply Chain Expertise</h3>
          </div>

          <div className="serviceDetail">
            <div className="header">
              <img
                src={banner}
                alt="Aviation Procurement & Supply Chain Expertise"
                className="img-fluid"
                title="Aviation Procurement & Supply Chain Expertise"
              />
              <p>
                At GGAS Maintenance Tooling &amp; Equipments (GGAS), we
                specialize exclusively in procurement and supply chain
                management for the aviation industry. Our goal is to deliver
                immediate value and continuously expand the strategic impact of
                procurement across your enterprise.
              </p>
            </div>
            <div className="body">
              <h4>Why Choose GGAS?</h4>
              <div className="row">
                {data.map((item, i) => {
                  return (
                    <div className="col-lg-3 col-md-4 col-sm-6" key={i}>
                      <div className="serviceItemCard">
                        <h6>{item.title}</h6>
                        <p>{item.description}</p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="footer">
              <h4>Elevate Your Aviation Procurement with GGAS</h4>
              <p>
                Partner with us to optimize your supply chain, reduce costs,
                improve compliance, and strengthen your competitive advantage in
                the demanding aviation market.
              </p>
              <p>
                Contact us today to learn how GGAS can support your procurement
                and supply chain goals.
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Procurement;
